import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  TemplateRef,
} from '@angular/core';

/**
 * Tooltip component
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'atx-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
  imports: [CommonModule],
})
export class TooltipComponent {
  /** Binding for the class name */
  @Input() public positionClass = '';
  /** Tooltip content. */
  @Input() public content: string | TemplateRef<unknown>;
  /** Custom classes */
  @Input() public customClass: string;
  /** Dependencies. */
  constructor(private cdr: ChangeDetectorRef) {}

  /** Method to change the position class used to positioning the tooltip arrow */
  public changePosition(position: string) {
    this.positionClass = position;
    this.cdr.detectChanges();
  }

  public isTemplate(item: string | TemplateRef<unknown>) {
    return item instanceof TemplateRef;
  }
}
